export default __webpack_public_path__ + "static/media/cross-editprofile.39364b9c.svg";